module.exports = "/images/cooper-8.jpg";